<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Solicitações</h5>
                <hr />
                <Card v-for="solicitacao in solicitacoes" :key="solicitacao.index" class="p-mb-2">
                    <template #title>Ponto {{ solicitacao.dataPonto }}</template>
                    <template #content>
                        <p><span class="p-text-bold">Solicitado: </span>{{ solicitacao.data }}</p>
                        <p><span class="p-text-bold">Tipo: </span>{{ solicitacao.tipo }}</p>
                        <p><span class="p-text-bold">Status: </span> 
                            <span class="p-text-bold" :class="aplicarBadgeStatus(solicitacao.status)">
                                {{ solicitacao.status }}
                            </span>
                        </p>
                    </template>
                </Card>
            </div>
            
        </div>        
    </div>
</template>

<script>
import PontoService from '@/service/PontoService';
import { mapGetters } from "vuex";
import { localeCalendarBR, exibirMensagem } from "@/global";

export default {   
    pontoService: null,
    data() {
        return {
            tipoFiltro: 'FILTRAR_PENDENTES',
            mesAno: new Date(),
            rangeData: "",
            localeCalendarBR: localeCalendarBR,
            solicitacoes: [],          
            filtro: {}          
        };
    },
    methods: {
        ...mapGetters('sessao', ['getUsuario', 'limparSessao']),      
        /**
         *
         */
        listar() {
            if(this.tipoFiltro == 'FILTRAR_PERIODO') {
                this.mesAno = new Date();
                this.listarPorPeriodo();
            } else if(this.tipoFiltro == 'FILTRAR_PENDENTES') {                
                this.listarPendentes();
            }                     
        },
        /**
         *
         */
         listarPorPeriodo() { 
            this.solicitacoes = [];             
            let requisicao = {
                id: this.getUsuario().id,
                grupo: this.getUsuario().grupo,
                mes: this.mesAno.getMonth() + 1,
                ano: this.mesAno.getFullYear(),
                tipoDispositivo: 'Web'
            }
            this.pontoService.solicitacoes(requisicao)
            .then((resp) => {
                resp.data.forEach((sol) => {                    
                    sol.data = this.formartarStrData(sol.data);
                    sol.dataPonto = this.formartarStrData(sol.dataPonto);                       
                    this.solicitacoes.push(sol);
                });
            })
            .catch((erro) => {
                if(erro.response.status == 401) {
                    this.logout();
                } else {
                    exibirMensagem(this, erro)
                }
            });
        },
        /**
         *
         */
         listarPendentes() { 
            this.solicitacoes = [];             
            let requisicao = {
                id: this.getUsuario().id,
                grupo: this.getUsuario().grupo,              
                tipoDispositivo: 'Web'
            }
            this.pontoService.solicitacoesPendentes(requisicao)
            .then((resp) => {
                resp.data.forEach((sol , i) => {
                    sol['index'] = i;                    
                    sol.data = this.formartarStrData(sol.data);
                    sol.dataPonto = this.formartarStrData(sol.dataPonto);                       
                    this.solicitacoes.push(sol);
                });
            })
            .catch((erro) => {
                if(erro.response.status == 401) {
                    this.logout();
                } else {
                    exibirMensagem(this, erro)
                }
            });
        },  
        /**
         *     
         */
        formartarStrData(strData) {
            let partes = strData.split("-");
            return partes[2] + "/" + partes[1] + "/" + partes[0];
        },  
        /**
         *
         * @param {*} status
         */
         aplicarBadgeStatus(status) {
            let badge = "ik-badge-success";
            if (status == "Pendente") {
                badge = "ik-badge-warnning";
            } else if (status == "Não Aprovado") {
                badge = "ik-badge-danger";
            }
            return badge;
        },     
        /**
         *
         */
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-40)+':'+(anoAtual+1);
        },
        /**
         * 
         */
         logout() {
          this.limparSessao();			
          this.$router.push('/login');
        } 
    },
    created() {
        this.pontoService = new PontoService();
        this.listar();
    },
    mounted() {
        this.criarRangeData();       
    },
};
</script>
<style scoped>
</style>